export enum APIResponse {
    INCORRECT_CAPTCHA_RESPONSE = 'INCORRECT_CAPTCHA_RESPONSE',
    SUCCESS = 'SUCCESS',
    CLIENT_NOT_FOUND = 'CLIENT_NOT_FOUND',
    INVALID_CLIENT_STATUS = 'INVALID_CLIENT_STATUS',
    INCORRECT_ANSWER = 'INCORRECT_ANSWER',
    EMAIL_ALREADY_IN_USE = 'EMAIL_ALREADY_IN_USE',
    TOKEN_ERROR = 'TOKEN_ERROR',
    INSUFFICIENT_CLIENT_DATA = 'INSUFFICIENT_CLIENT_DATA',
    USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS'
}
